module.exports = "https://static.wmbcdn.com/uniweb/images/22c84d6a4bbd6fce74ca9ec850949ba2.svg";